import { Modal } from 'antd';
import { useCallback, useContext } from 'react';

import { AppContext } from 'context/AppContext';
import Notifications from './index';

const NotificationsModal: React.FC = () => {
  const { modal } = useContext(AppContext);
  const { notificationsModalOpen, setNotificationsModalOpen } = modal;

  const onClose = useCallback(() => {
    setNotificationsModalOpen(false);
  }, [setNotificationsModalOpen]);

  return (
    <Modal
      open={notificationsModalOpen}
      onCancel={onClose}
      footer={null}
      width={600}
      title={null}
    >
      <Notifications closeHandler={onClose} />
    </Modal>
  );
};

export default NotificationsModal;